import './ChartWrapper.scss';

import { IconButton, Menu, MenuItem, Typography } from '@trackman/web-shared-components';

import { ReactNode, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as ThreeDotsIcon } from 'svg/ThreeDots.svg';
import { ReactComponent as SixDotsIcon } from 'svg/SixDots.svg';
import { ReactComponent as AdjustmentsIcon } from 'svg/Adjustments.svg';
import { ReactComponent as MinusCircleIcon } from 'svg/MinusCircle.svg';
import { ReactComponent as CheckIcon } from 'svg/Check.svg';

export const DRAG_HANDLER_CLASS = 'ChartWrapper-drag-handle';

type Props = {
  children: ReactNode;
  chartTitle: string;
  chartSubTitle?: string;
  hideChartTitle?: boolean;
  isEditMode: boolean;
  isEditingThisChart: boolean;
  isEditingOtherChart: boolean;
  isThisChartEditable: boolean;
  onEditClick: () => void;
  onHideClick: () => void;
};

const ChartWrapper = ({
  children,
  chartTitle,
  chartSubTitle,
  hideChartTitle,
  isEditMode,
  isEditingThisChart,
  isEditingOtherChart,
  isThisChartEditable,
  onEditClick,
  onHideClick,
}: Props) => {
  const { t } = useTranslation();

  const [isChartMenuOpen, setIsChartMenuOpen] = useState(false);

  const menuButtonRef = useRef<HTMLButtonElement>(null);

  return (
    <div className='ChartWrapper-container'>
      <div className={`ChartWrapper-header ${isEditMode && !isEditingOtherChart ? 'is-editing-layout' : ''}`}>
        <div className='ChartWrapper-title'>
          <div className={DRAG_HANDLER_CLASS}>
            <SixDotsIcon />
          </div>
          {!hideChartTitle && (
            <Typography variant='h2' component='div' className='ChartWrapper-title-text'>
              {chartTitle}
              {chartSubTitle && <div style={{ fontSize: '11px', color: '#A0A0A0', fontWeight: 'normal' }}>{chartSubTitle}</div>}
            </Typography>
          )}
        </div>
        <>
          <IconButton
            ref={menuButtonRef}
            disabled={!isEditMode || isEditingOtherChart}
            intent={isEditingThisChart ? 'primary' : 'secondary'}
            onClick={() => (isEditingThisChart ? onEditClick() : setIsChartMenuOpen((curr) => !curr))}
            icon={() => (isEditingThisChart ? <CheckIcon /> : <ThreeDotsIcon />)}
            className='ChartWrapper-edit-button'
          />
          <Menu
            open={isChartMenuOpen}
            anchorEl={menuButtonRef.current}
            onClose={() => setIsChartMenuOpen(false)}
            style={{ marginTop: '6px' }}
          >
            {isThisChartEditable && (
              <MenuItem
                StartIcon={AdjustmentsIcon}
                label={t('Adjust')}
                onClick={() => {
                  onEditClick();
                  setIsChartMenuOpen(false);
                }}
                style={{ width: '112px' }}
              />
            )}
            <MenuItem
              StartIcon={MinusCircleIcon}
              label={t('Remove')}
              onClick={() => {
                onHideClick();
                setIsChartMenuOpen(false);
              }}
              style={{ width: '112px' }}
            />
          </Menu>
        </>
      </div>
      <div className='ChartWrapper-content'>{children}</div>
    </div>
  );
};

export default ChartWrapper;
